import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=9f8d3cd4"
import script from "./menuItem.vue?vue&type=script&lang=js"
export * from "./menuItem.vue?vue&type=script&lang=js"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=9f8d3cd4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports